import React from "react";
const Footer = () => {
  return (
    <>
    
    <footer style={footerStyle}>  
      <div style={logoStyle}>
        {" "}
        {/* Logo at top left corner */}
        <img src="./images/Maersk_Logo_RGB_Neg_Txt.svg" alt="Logo" height="100" />
      </div>
      <div style={linksContainerStyle}>
        {" "}
        {/* Links at the center */}
        <h3>All times displayed are in Coordinated Universal Time (UTC)</h3>
      </div>
      <div style={labelStyle}>
        {" "}
        {/* Text label at bottom right */}
        Designed and developed by TechOps Tooling
      </div>
    </footer>
    </>
  );
};

// Styles
const footerStyle = {
  backgroundColor: "#00243D",
  padding: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "fixed",
  color: "white",
  width: "100%",
  position: "fixed",
  height: "6vh",
  bottom: 0,
  right: 0,
  zindex: 1000,
  //   marginTop: '100px',
};
const logoStyle = {
  marginRight: "20px",
};
const linksContainerStyle = {
  display: "flex",
  justifyContent: "center",
  float: "center",
  textAlign: "center",
  color: "white",
  width: "100%",
  //   textDecoration: 'none',
};
const labelStyle = {
  marginLeft: "auto",
  width: "600px",
};
export default Footer;
